module.exports = __webpack_public_path__ + "img/2.acd988b9.jpeg";